import Vue from "vue";
//import axios from "axios";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import "./helpers/VeeValidateRules";
import { SchemaSyncHandler } from "./helpers/InitialiseIndexedDB";
import "./registerServiceWorker";

SchemaSyncHandler.sync();

Vue.config.productionTip = false;
/*
Vue.config.errorHandler = (err, vm, info) => {
  // err: error tryace
  // vm: component in which error occured
  // info: Vue specific error information such as lifecycle hooks, events etc.
  //debugger;
  const eData = {
    error: err.message,
    info: info,
    stack: err.stack,
  }; 
  axios.post(`${process.env.BASE_URL}Randomisation/LogClientError`, eData);
};
*/
router.beforeEach(async (to, from, next) => {
  //debugger;
  const appUserId = await store.dispatch("fetchAppUserId");
  if (to.matched.some((record) => record.meta.activeUser) && !appUserId) {
    next({
      name: "activate-profile",
    });
  } else if (to.name == "post-rand") {
    store.commit("setAppBusyAnimation", true);
    next();
  } else {
    next();
  }
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
